import css from "./footer.module.css"
import {A} from "@solidjs/router"
import {FaBrandsFacebook, FaBrandsInstagram} from "solid-icons/fa";
import Section from "./Section";


export default function Footer() {
    return (
        <footer class={css.footer}>
            <Section class={css.socials}>
                <p>Join our yoga community online!</p>
                <div class={css.socialLinks}>
                    <A href="https://www.facebook.com/gracefulspaceyoga/" target="_blank"
                       rel="noopener noreferrer"><FaBrandsFacebook/></A>
                    <A href="https://www.instagram.com/gracefulspaceyoga/" target="_blank"
                       rel="noopener noreferrer"><FaBrandsInstagram/></A>
                </div>
            </Section>
            <Section class={css.legalBanner}>
                <nav>
                    <A href="/terms">Terms & Conditions</A>
                    <A href="/privacy">Privacy Policy</A>
                </nav>
                <div>
                    &copy; {new Date().getFullYear()} Graceful Space Yoga
                </div>
            </Section>
        </footer>
    )
}